type BindQuoteModalType = 'submissionSummary' | 'changelog' | 'rolesManagement' | 'multiPolicyBind' | 'exitDialog';

const BindQuoteModalTypes = {
  submissionSummary: 'submissionSummary' as BindQuoteModalType,
  changelog: 'changelog' as BindQuoteModalType,
  rolesManagement: 'rolesManagement' as BindQuoteModalType,
  multiPolicyBind: 'multiPolicyBind' as BindQuoteModalType,
  exitDialog: 'exitDialog' as BindQuoteModalType,
};

export { BindQuoteModalTypes };
export type { BindQuoteModalType };
